import BigNumber from 'bignumber.js'
import darkvaultABI from 'config/abi/darkvault.json'
import dmdvaultABI from 'config/abi/dmdvault.json'
import { getAddress } from 'utils/addressHelpers'
import { BIG_TEN } from 'utils/bigNumber'
import multicall from 'utils/multicall'
import { Vault } from '../types'

type PublicVaultData = {
  pricePerFullShare: BigNumber
  tokenAmountTotal: BigNumber
}

const fetchVault = async (vault: Vault): Promise<PublicVaultData> => {
  try {
    const { name, contractAddress, token } = vault
    let methodName = ''
    let abi = []
    switch (name) {
      case 'DMD':
        methodName = 'balanceOf'
        abi = dmdvaultABI
        break
      default:
        methodName = 'balance'
        abi = darkvaultABI
        break
    }
    const calls = [
      {
        address: getAddress(contractAddress),
        name: methodName,
      },
      {
        address: getAddress(contractAddress),
        name: 'getPricePerFullShare',
      },
    ]
    const [tokenBalanceToken, pricePerFullShareFC] = await multicall(abi, calls)

    const tokenAmountTotal = new BigNumber(tokenBalanceToken).div(BIG_TEN.pow(new BigNumber(token.decimals || 18)))

    return {
      pricePerFullShare: new BigNumber(pricePerFullShareFC),
      tokenAmountTotal,
    }
  } catch (error) {
    console.error(error)
    return null
  }
}

export default fetchVault
